import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext();

const THEME_KEY = 'rmd_theme';
const FIRST_VISIT_KEY = 'rmd_first_visit_done';

export const THEMES = {
  light: 'presidential-light',
  dark: 'presidential-dark',
};

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    const saved = localStorage.getItem(THEME_KEY);
    return saved || null; // null = no preference yet (first visit)
  });

  const isFirstVisit = !localStorage.getItem(FIRST_VISIT_KEY);

  const setTheme = useCallback((t) => {
    setThemeState(t);
    localStorage.setItem(THEME_KEY, t);
  }, []);

  const markFirstVisitDone = useCallback(() => {
    localStorage.setItem(FIRST_VISIT_KEY, 'true');
  }, []);

  // Apply theme class to document
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove(THEMES.light, THEMES.dark);
    if (theme) {
      root.classList.add(theme);
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{
      theme: theme || THEMES.dark, // default to dark if not set
      rawTheme: theme, // null if never chosen
      setTheme,
      isFirstVisit,
      markFirstVisitDone,
      isDark: (theme || THEMES.dark) === THEMES.dark,
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}
